import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '../../../services/productservice';
import { Product } from '../../../services/product';
import { Router } from '@angular/router';
import { Carousel } from 'primeng/carousel';
import { highlightsProductsService } from 'src/services/highlightsProducts.service';

@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss'],
})
export class HighlightsComponent implements OnInit {
  @Input() highlightsProducts: Product[] = [];
  responsiveOptions: any;
  public pageNumber: number = 0;
  language: string;
  //highlightsProducts: Product[]=[];
  constructor(
    private productService: ProductService,
    private highlightsProductsService: highlightsProductsService,
    private router: Router
  ) {
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    this.highlightsProductsService.getHighlightsProducts().subscribe((value) => {
      if (value !== undefined) {
        this.highlightsProducts = value;
      }
    });
    setTimeout(() => {
      if (this.language.toLowerCase() === 'ru') {
        let catSection = document.querySelector('.viewall-btn');
        //console.log(catSection);
        catSection.classList.add('homeviewall-btn-moreright');
      }
    }, 200);
  }
  viewAllHighLights() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/blog']));
  }
  viewBlog(item: any) {
    var queryParams = this.productService.getBlogViewNode(item);
    var url = '/blog-details/' + item.nid + '/' + queryParams;
    window.open(url, '_blank');
  }
}
